






















// Importing components
import BaseCategorySearch from '@/ui/BaseCategorySearch.vue';

export default {
    name: 'TheWelcomeHeader',
    components: {
        BaseCategorySearch,
    },
    props: {
        town: String,
        ekatte: String,
    },
};
